import ModelTypeConstants from 'constants/ModelTypeConstants';

export type BoltzGenTargetType = ModelTypeConstants.PROTEIN | ModelTypeConstants.MOLECULE;

export interface BoltzGenInput {
  minLength: number;
  maxLength: number;
  proteinIds: Array<string>;
  moleculeIds: Array<string>;
}

// Keep in sync with benchling/model_hub/constants.py
export const MAX_BOLTZGEN_TARGET_PROTEIN_LENGTH = 1000;
export const MAX_BOLTZGEN_TARGET_MOLECULE_HEAVY_ATOM_COUNT = 1000;
export const MAX_BOLTZGEN_DESIGN_PROTEIN_LENGTH = 1000;
